/**
 * Resolve a bare /skill to /ability:skill at SUBMIT (never on a keystroke).
 * Moved out of MessageInput verbatim so the Dock's pill expands a slash
 * command on a task's screen by the same rule.
 */
import { resolveSlash, type SkillIndex } from "@/lib/abilities/slashResolver";

export function expandSlashOnSubmit(
  trimmed: string,
  index: SkillIndex
): string {
  if (!trimmed) return trimmed;
  const resolution = resolveSlash(trimmed, index);
  if (resolution.kind === "expanded") return resolution.text;
  if (resolution.kind === "ambiguous") {
    // Phase 1: log + send original; proper picker UI comes in Phase 2
    console.warn(
      "[abilities] ambiguous slash command — sending as-is:",
      resolution.original,
      resolution.candidates
    );
  }
  return trimmed;
}
